import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-apply',
  templateUrl: './online-apply.component.html',
  styleUrls: ['./online-apply.component.css']
})
export class OnlineApplyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
